import { defineStore } from 'pinia'
import request from '@/utils/request'
import { useAppStore } from '@/stores/app'

export const useTermsStore = defineStore('terms', {
  state: () => ({
  }),

  getters: {
  },

  actions: {
    getLastUpdated () {
      return request
        .post(`/api/site/latest-update/`)
        .then(({ data }) => {
          const appStore = useAppStore()
          appStore.setLastUpdate(data)
        })
    },
  }
})
